import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import styled from "styled-components";
import otpImg from "../../Images/otp.svg";

const VerifyOtp = ({ onVerifyOtp }) => {
  const [loading, setloading] = useState(false);
  const [loadingIcon, setloadingIcon] = useState("pi pi-save");
  const [disableSubmit, setDisableSubmit] = useState(false);

  const otpRefs = useRef([]);
  const addRef = (el) => {
    if (el && !otpRefs.current.includes(el)) {
      otpRefs.current.push(el);
    }
  };

  const handleInputChange = (e, index) => {
    formik.setFieldValue(`otp${index + 1}`, e.target.value);

    if (e.target.value.length === 1 && index < 4) {
      otpRefs.current[index + 1].focus();
    } else if (e.target.value === "" && index > 0) {
      // keyCode 8 is for backspace
      otpRefs.current[index - 1].focus();
    }
  };

  const handleFocus = (e) => {
    // Set the cursor to the end
    const valueLength = e.target.value.length;
    e.target.setSelectionRange(valueLength, valueLength);
  };

  const handleKeyNavigation = (e, index) => {
    if (e.keyCode === 37 && index > 0) {
      // left arrow key
      otpRefs.current[index - 1].focus();
    } else if (e.keyCode === 39 && index < 4) {
      // right arrow key
      otpRefs.current[index + 1].focus();
    }
  };

  const formik = useFormik({
    initialValues: {
      otp1: "",
      otp2: "",
      otp3: "",
      otp4: "",
      otp5: "",
    },
    onSubmit: async (values) => {
      setloading(true);
      setloadingIcon("pi pi-spin pi-spinner");
      try {
        const otp =
          values.otp1 + values.otp2 + values.otp3 + values.otp4 + values.otp5;
        await onVerifyOtp(otp);
        formik.resetForm();
      } catch (err) {
        console.error("Error verifying OTP:", err);
      } finally {
        setloading(false);
        setloadingIcon("pi pi-save");
      }
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  useEffect(() => {
    if (
      !formik.values.otp1 ||
      !formik.values.otp2 ||
      !formik.values.otp3 ||
      !formik.values.otp4 ||
      !formik.values.otp5
    ) {
      setDisableSubmit(true);
    } else setDisableSubmit(false);
  }, [
    formik.values.otp1,
    formik.values.otp2,
    formik.values.otp3,
    formik.values.otp4,
    formik.values.otp5,
  ]);

  return (
    <div className="card Card__Round" style={{ backgroundColor: "#366c77" }}>
      <div className="Form__Header">
        <h1 style={{ color: "#ffffff" }}> Verify OTP </h1>
      </div>
      <div>
        <image src={otpImg} />
      </div>
      <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
        <div className="p-mt-4">
          <div>
            <p style={{ color: "#ffffff" }}>
              {`Please enter the OTP code sent to your registered Mobile Number / Email Address.`}
              <br />
            </p>
            <div>
              {[1, 2, 3, 4, 5].map((_, index) => (
                <Input
                  key={index}
                  maxLength="1"
                  ref={addRef}
                  onChange={(e) => handleInputChange(e, index)}
                  onKeyDown={(e) => handleKeyNavigation(e, index)}
                  onFocus={handleFocus}
                  value={formik.values[`otp${index + 1}`]}
                  name={`otp${index + 1}`}
                  type="text"
                />
              ))}
              {getFormErrorMessage("otp")}
            </div>
            <div className="GenerateDown__Btn p-mt-4">
              <Button
                disabled={loading || disableSubmit}
                icon={loadingIcon || ""}
                iconPos="right"
                label={"Verify"}
                className="Btn__Transparent"
                type="submit"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

const Input = styled.input`
  width: 40px;
  margin: 0 5px;
  text-align: center;
`;

export default VerifyOtp;
